module.exports = __webpack_public_path__ + "img/sign-up-img.496c5ed6.svg";